import { Link } from "react-router-dom";

const blogPosts = [
  {
    title: "Vigorbuy Sheet Complete Guide: How to Use the Spreadsheet for Smarter Shopping in 2026",
    excerpt: "Learn everything about the Vigorbuy Sheet - from navigating product categories and understanding QC ratings to finding the best deals across shoes, hoodies, jackets, and accessories. This comprehensive guide covers all 14 product categories with step-by-step instructions for beginners.",
    date: "June 28, 2026",
    link: "/vigorbuy-sheet-guide",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20workspace%20with%20open%20laptop%20showing%20colorful%20data%20dashboard%2C%20ceramic%20coffee%20mug%20and%20leather%20notebook%20nearby%2C%20warm%20morning%20sunlight%20through%20window%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20productivity%20lifestyle%20photography%2C%20neutral%20beige%20and%20cream%20tones%2C%20calm%20focused%20atmosphere&width=800&height=500&seq=blog-guide-v3&orientation=landscape",
  },
  {
    title: "Vigorbuy QC Guide: How to Avoid Low Quality Products in 2026",
    excerpt: "Learn how to read QC photos, spot common defects, and use the Vigorbuy Spreadsheet quality ratings to ensure you only buy top-quality items. A complete quality control guide covering all 14 product categories.",
    date: "June 27, 2026",
    link: "/article/vigorbuy-qc-guide",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Professional%20quality%20inspection%20workspace%20with%20magnifying%20glass%20examining%20fabric%20detail%20on%20light%20gray%20desk%2C%20ruler%20and%20checklist%20beside%2C%20bright%20natural%20window%20light%2C%20clean%20editorial%20photography%2C%20crisp%20focus%20on%20textile%20texture%2C%20warm%20neutral%20color%20palette%2C%20soft%20shadows%2C%20commercial%20aesthetic&width=800&height=500&seq=blog-qc-v3&orientation=landscape",
  },
  {
    title: "25 Best Shoes from Vigorbuy Spreadsheet: Updated Weekly in 2026",
    excerpt: "Discover the top 25 shoe finds from the Vigorbuy Spreadsheet. From trending sneakers and athletic footwear to casual everyday shoes, see what smart shoppers are buying this year across all styles and price points.",
    date: "June 26, 2026",
    link: "/article/best-vigorbuy-shoes-2026",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Artistic%20sneaker%20arrangement%20on%20light%20concrete%20surface%2C%20three%20modern%20sneakers%20in%20cream%20olive%20and%20charcoal%20tones%2C%20natural%20window%20light%20casting%20soft%20shadows%2C%20minimalist%20editorial%20fashion%20photography%2C%20clean%20contemporary%20aesthetic%2C%20warm%20neutral%20atmosphere%2C%20top-down%20flat%20lay%20composition&width=800&height=500&seq=blog-shoes-v3&orientation=landscape",
  },
  {
    title: "Vigorbuy Shipping Guide 2026: Costs, Delivery Times & Pro Tips",
    excerpt: "Master Vigorbuy Spreadsheet shipping with our comprehensive guide covering shipping costs, delivery estimates for USA UK Canada and Europe, carrier comparisons, and expert consolidation tips to save money.",
    date: "June 25, 2026",
    link: "/article/vigorbuy-shipping-guide",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Organized%20shipping%20station%20with%20kraft%20paper%20wrapped%20parcels%20on%20light%20wooden%20table%2C%20measuring%20tape%20labels%20and%20scissors%20arranged%20neatly%2C%20world%20map%20artwork%20on%20wall%20behind%2C%20natural%20daylight%2C%20clean%20orderly%20aesthetic%2C%20warm%20tones%2C%20editorial%20product%20photography%2C%20soft%20shadows&width=800&height=500&seq=blog-shipping-v3&orientation=landscape",
  },
  {
    title: "Vigorbuy vs Other Shopping Platforms: Honest 2026 Comparison",
    excerpt: "An unbiased comparison of Vigorbuy Spreadsheet against other popular shopping platforms. See how Vigorbuy stacks up in product selection quality, QC transparency, pricing value, and overall user experience.",
    date: "June 24, 2026",
    link: "/article/vigorbuy-vs-other-platforms",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Modern%20tech%20comparison%20scene%20with%20two%20smartphones%20and%20tablet%20on%20light%20wood%20desk%2C%20one%20displaying%20spreadsheet%20interface%20and%20other%20showing%20shopping%20app%2C%20natural%20window%20light%2C%20clean%20minimal%20workspace%20aesthetic%2C%20editorial%20technology%20lifestyle%20photography%2C%20soft%20shadows%2C%20warm%20neutral%20palette&width=800&height=500&seq=blog-compare-v3&orientation=landscape",
  },
  {
    title: "15 Best Vigorbuy Hoodies & Sweaters: Cozy Finds for 2026",
    excerpt: "Explore the top-rated hoodies and sweaters on the Vigorbuy Spreadsheet. From heavyweight 500GSM cotton pullovers to stylish zip-ups and premium knitwear, find your perfect cozy layer this season.",
    date: "June 23, 2026",
    link: "/article/best-vigorbuy-hoodies-2026",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Cozy%20fashion%20flat%20lay%20with%20three%20folded%20premium%20cotton%20hoodies%20in%20sage%20green%20charcoal%20and%20cream%20on%20light%20linen%20fabric%2C%20natural%20sunlight%20streaming%20across%2C%20warm%20relaxed%20aesthetic%2C%20soft%20textile%20textures%2C%20minimalist%20composition%2C%20lifestyle%20product%20photography%2C%20earthy%20neutral%20tones&width=800&height=500&seq=blog-hoodies-v3&orientation=landscape",
  },
  {
    title: "Vigorbuy Beginner Guide 2026: Step-by-Step First-Time Tutorial",
    excerpt: "New to Vigorbuy Spreadsheet? This beginner-friendly tutorial walks you through everything from understanding the 14 categories and reading product listings to completing your first purchase with confidence.",
    date: "June 22, 2026",
    link: "/article/vigorbuy-beginner-guide",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Welcoming%20learning%20workspace%20with%20open%20laptop%20on%20light%20oak%20desk%2C%20handwritten%20notebook%20with%20colorful%20tabs%20and%20pen%2C%20warm%20ceramic%20tea%20mug%2C%20gentle%20morning%20sunlight%2C%20organized%20approachable%20aesthetic%2C%20editorial%20education%20photography%2C%20soft%20focus%20background%2C%20warm%20inviting%20tones&width=800&height=500&seq=blog-beginner-v3&orientation=landscape",
  },
  {
    title: "Best Bags & Backpacks from Vigorbuy Spreadsheet: Top Picks 2026",
    excerpt: "Discover the most popular bags backpacks tote bags and travel accessories from the Vigorbuy Spreadsheet. Curated picks with quality ratings material comparisons and style recommendations.",
    date: "June 21, 2026",
    link: "/article/best-vigorbuy-bags-2026",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Elegant%20bag%20collection%20on%20light%20oak%20surface%2C%20leather%20tote%20backpack%20and%20crossbody%20bag%20arranged%20harmoniously%2C%20soft%20natural%20side%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20photography%2C%20premium%20minimalist%20composition%2C%20soft%20shadows%2C%20sophisticated%20style%2C%20cream%20and%20tan%20palette&width=800&height=500&seq=blog-bags-v3&orientation=landscape",
  },
  {
    title: "Is Vigorbuy Safe & Legit? Complete Trust & Safety Review 2026",
    excerpt: "An in-depth safety review of the Vigorbuy Spreadsheet. Learn about security practices community trust factors payment safety and how to shop securely using the Vigorbuy platform with confidence.",
    date: "June 20, 2026",
    link: "/article/is-vigorbuy-safe-legit",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Modern%20security%20trust%20concept%20with%20minimalist%20desk%20setup%2C%20laptop%20displaying%20shield%20icon%20interface%2C%20small%20padlock%20on%20light%20wood%20surface%2C%20soft%20natural%20lighting%2C%20clean%20professional%20atmosphere%2C%20reassuring%20visual%20tone%2C%20warm%20neutral%20colors%2C%20editorial%20technology%20photography%2C%20calm%20shadows&width=800&height=500&seq=blog-safety-v3&orientation=landscape",
  },
  {
    title: "Best Vigorbuy Jackets & Outerwear: Top Styles for Every Season 2026",
    excerpt: "Find the best jackets coats and outerwear on the Vigorbuy Spreadsheet. From lightweight spring windbreakers and classic denim jackets to premium winter coats with QC reviews and seasonal style guides.",
    date: "June 18, 2026",
    link: "/article/best-vigorbuy-jackets-2026",
    isInternal: true,
    image: "https://readdy.ai/api/search-image?query=Stylish%20outerwear%20display%20with%20bomber%20jacket%20denim%20jacket%20and%20lightweight%20windbreaker%20on%20wooden%20hangers%2C%20light%20cream%20wall%20background%2C%20natural%20daylight%20from%20side%20window%2C%20clean%20minimalist%20editorial%20aesthetic%2C%20fashion%20product%20photography%2C%20soft%20shadows%2C%20warm%20neutral%20tones&width=800&height=500&seq=blog-jackets-v3&orientation=landscape",
  },
  {
    title: "Best Vigorbuy Finds 2026: Top Products from Every Category",
    excerpt: "Discover the most popular products from the Vigorbuy Spreadsheet this year. From trending sneakers and premium hoodies to must-have accessories and bestselling perfumes - see what shoppers are loving right now.",
    date: "June 25, 2026",
    link: "https://kaspreadsheet.com",
    isInternal: false,
    image: "https://readdy.ai/api/search-image?query=Curated%20product%20collection%20flat%20lay%20on%20light%20cream%20linen%20surface%2C%20sneakers%20hoodie%20sunglasses%20and%20watch%20arranged%20artfully%2C%20warm%20natural%20lighting%20from%20window%2C%20editorial%20fashion%20lifestyle%20aesthetic%2C%20soft%20shadows%2C%20clean%20harmonious%20composition%2C%20neutral%20earthy%20tones%2C%20aspirational%20mood&width=800&height=500&seq=blog-finds-v3&orientation=landscape",
  },
  {
    title: "Vigorbuy Accessories Guide: Best Sunglasses, Watches & Jewelry 2026",
    excerpt: "Complete the look with the best accessories from the Vigorbuy Spreadsheet. From classic sunglasses and minimalist watches to stylish jewelry and small leather goods that elevate any outfit instantly.",
    date: "June 15, 2026",
    link: "https://kaspreadsheet.com",
    isInternal: false,
    image: "https://readdy.ai/api/search-image?query=Fashion%20accessories%20flat%20lay%20with%20sunglasses%20leather%20watch%20gold%20jewelry%20and%20silk%20scarf%20on%20light%20marble%20surface%2C%20natural%20daylight%2C%20elegant%20editorial%20aesthetic%2C%20soft%20luxurious%20composition%2C%20warm%20neutral%20tones%2C%20soft%20shadows%2C%20sophisticated%20lifestyle%20product%20photography&width=800&height=500&seq=blog-accessories-v3&orientation=landscape",
  },
];

export default function BlogPreview() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-5xl font-extrabold text-foreground-950 font-heading tracking-tight mb-4">
            Vigorbuy Sheet Guides &amp; Articles
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto">
            Expert shopping guides, product spotlights, comparisons, and tutorials to help you get the most out of your Vigorbuy Spreadsheet experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {blogPosts.map((post) => (
            <article
              key={post.title}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 group flex flex-col"
            >
              {/* Image */}
              <div className="relative w-full h-44 md:h-48 overflow-hidden flex-shrink-0">
                <img
                  src={post.image}
                  alt={post.title}
                  title={post.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-5 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 mb-2 line-clamp-2 leading-snug font-heading">
                  {post.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 mb-4 line-clamp-2 leading-relaxed flex-1">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-xs text-foreground-400">{post.date}</span>

                  {post.isInternal ? (
                    <Link
                      to={post.link}
                      className="inline-flex items-center gap-1.5 text-xs md:text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                    >
                      Read More
                      <i className="ri-arrow-right-line text-xs"></i>
                    </Link>
                  ) : (
                    <a
                      href={post.link}
                      target="_blank"
                      rel="noopener nofollow"
                      className="inline-flex items-center gap-1.5 text-xs md:text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                    >
                      Learn More
                      <i className="ri-external-link-line text-xs"></i>
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Browse All CTA */}
        <div className="text-center mt-10">
          <Link
            to="/vigorbuy-sheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
          >
            View All Shopping Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}